module.exports = __webpack_public_path__ + "static/media/2.f1aa6cbd.png";